/* eslint-disable @next/next/no-img-element */
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { ASSET_PREFIX, PaymentSchedule } from 'utils/constants';
import { EntryMethod } from '../EntryMethod';
import { getNumberOfTreesPlanted } from '../helpers/getNumberOfTreesPlanted';
import { TotalCost } from '../with-one-time-purchases/TotalCost';

export const OrderSummaryMain = observer(() => {
  const { days, dayEnabled, entryMethod, lines, boosted, paymentSchedule } =
    useEnterStore();

  const numberOfTreesPlantedPerWeek = getNumberOfTreesPlanted(
    entryMethod,
    dayEnabled.TUESDAY,
    dayEnabled.FRIDAY
  );

  const drawsPerWeek = days.length;

  return (
    <div
      className="py-6"
      style={{ border: '2px solid  #e1e1e1', borderRadius: '10px' }}
    >
      <h2
        style={{
          fontSize: 20,
          fontFamily: 'Montserrat-ExtraBold, Montserrat !important',
        }}
        className={
          'normal-case spacing-normal tracking-normal font-extrabold pt-5'
        }
      >
        Order Summary
      </h2>

      <div className="px-4 flex flex-col">
        <div className="mx-auto py-5 flex flex-col ">
          <p style={{ fontSize: 13 }} className="medium summaryPoint">
            <img
              src={`${ASSET_PREFIX}/images/ticket.svg`}
              style={{
                display: 'inline',
                verticalAlign: 'middle',
                marginRight: '0.9em',
                width: '20px',
              }}
              alt=""
            />
            {lines.length} entr{lines.length > 1 ? 'ies' : 'y'} per draw{' '}
          </p>
          <div className="summaryPoint flexRow" style={{ marginBottom: '1em' }}>
            <img
              src={`${ASSET_PREFIX}/images/enter/calendar-icon.svg`}
              style={{
                display: 'inline',
                verticalAlign: 'middle',
                marginRight: '0.9em',
                width: '20px',
              }}
              alt=""
            />
            <p style={{ fontSize: 13 }}>
              {drawsPerWeek} draw
              {drawsPerWeek === 1 ? '' : 's'} per {'week'}{' '}
              <span style={{ whiteSpace: 'nowrap' }}>
                (
                {days
                  .map(
                    (day) =>
                      day.charAt(0).toUpperCase() + day.slice(1).toLowerCase()
                  )
                  .join(' & ')}
                )
              </span>
            </p>
          </div>

          <p
            className="medium summaryPoint"
            style={{
              opacity: numberOfTreesPlantedPerWeek === 0 ? 0.5 : 1.0,
              fontSize: 13,
            }}
          >
            <img
              src={`${ASSET_PREFIX}/images/common/trees-planted-solid-icon.svg`}
              style={{
                display: 'inline',
                verticalAlign: 'middle',
                marginRight: '0.9em',
                width: '20px',
              }}
              alt=""
            />
            {numberOfTreesPlantedPerWeek === 1
              ? '1 tree planted'
              : `${numberOfTreesPlantedPerWeek} trees planted`}
            {entryMethod !== EntryMethod.OneOff &&
              ` per ${
                paymentSchedule === PaymentSchedule.MONTHLY ? 'month' : 'week'
              }`}
          </p>

          {boosted && (
            <p
              style={{
                fontSize: 13,
              }}
              className="medium summaryPoint"
            >
              <>
                <img
                  src={`${ASSET_PREFIX}/images/enter/rocket.png`}
                  className="orderSummaryIcon"
                  alt=""
                  style={{
                    display: 'inline',
                    verticalAlign: 'middle',
                    marginRight: '0.9em',
                    width: '20px',
                  }}
                />
                Boosted jackpot
              </>
            </p>
          )}
        </div>
        <TotalCost />
      </div>

      <div className="w-full flex justify-center mt-6">
        <strong style={{ fontSize: 13 }}>👋 Cancel anytime 👋</strong>
      </div>
    </div>
  );
});
